import { render } from "./DataIndex.vue?vue&type=template&id=49bd1b32"
import script from "./DataIndex.vue?vue&type=script&lang=js"
export * from "./DataIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__